import { FC } from 'react'
import styled from 'styled-components'
import { Scroll } from '../../scroll'

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    max-height: 160px;
    box-sizing: border-box;
    margin-bottom: 0.5em;

    &::-webkit-scrollbar-thumb {
        // background-color: ${(p) => p.theme.colors.primaryGreen};
    }
`

const ImageBorder = styled.div<{ $selected?: boolean }>`
    width: auto;
    height: 100px;
    aspect-ratio: 1;
    box-sizing: border-box;
    padding: 4px;
    border: 3px solid
        ${(p) => (p.$selected ? p.theme.colors.primaryGreen : 'transparent')};
`

const Image = styled.img`
    width: auto;
    height: 86px;
    aspect-ratio: 1;
    object-fit: cover;
    box-sizing: border-box;
`

interface Props {
    urls: string[]
    selectedImageUrl: string
    onSelect: (url: string) => void
}

export const HorizontalImageScroll: FC<Props> = ({
    selectedImageUrl,
    urls,
    onSelect,
}) => {
    return (
        <Scroll maxWidth="100%">
            <Container>
                {urls.map((url, index) => {
                    return (
                        <ImageBorder
                            id={`image-slideshow-horizontal-${index}`}
                            key={index}
                            $selected={url === selectedImageUrl}
                            onClick={() => {
                                onSelect(url)
                            }}
                        >
                            <Image key={index} src={url} />
                        </ImageBorder>
                    )
                })}
            </Container>
        </Scroll>
    )
}
